export const ACCREDITATION_ROLES = {
  player: {
    value: 0,
    label: 'Player',
  },

  playerSupportManager: {
    value: 1,
    label: 'Player Support - Manager',
  },

  caddie: {
    value: 2,
    label: 'Caddie',
  },

  playerGuest: {
    value: 3,
    label: 'Player Guest',
  },

  playerVIP: {
    value: 5,
    label: 'Player VIP',
  },

  playerSupportCoach: {
    value: 6,
    label: 'Player Support - Coach',
  },

  playerSupportMedical: {
    value: 7,
    label: 'Player Support - Medical/ Physio',
  },

  playerSupportTranslator: {
    value: 8,
    label: 'Player Support - Translator',
  },

  playerChildren: {
    value: 9,
    label: 'Player Children',
  },

  playerSupportManagerWithDining: {
    value: 10,
    label: 'Player Support - Manager with Dining',
  },

  playerGuestWithDining: {
    value: 11,
    label: 'Player Guest with Dining',
  },

  playerVIPwithDining: {
    value: 12,
    label: 'Player VIP with Dining',
  },

  playerSupportCoachWithDining: {
    value: 13,
    label: 'Player Support - Coach with Dining',
  },

  playerSupportMedicalWithDining: {
    value: 14,
    label: 'Player Support - Medical/ Physio with Dining',
  },

  playerSupportTranslatorWithDining: {
    value: 15,
    label: 'Player Support - Translator with Dining',
  },

  unknown: {
    value: 99,
    label: 'Unknown',
  },
};

export const IMPLICIT_NOMINATED_FOR_DINNER_ROLES = [
  ACCREDITATION_ROLES.player.value,
  ACCREDITATION_ROLES.caddie.value,
  ACCREDITATION_ROLES.playerChildren.value,
];

export const ACCREDITATION_ROLE_VALUES = Object.values(ACCREDITATION_ROLES).map(
  role => role.value,
);
